import { render, staticRenderFns } from "./PhotosViewer.vue?vue&type=template&id=d7c07926"
import script from "./PhotosViewer.vue?vue&type=script&lang=ts"
export * from "./PhotosViewer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports